export let trackingId = 'UA-135258597-1'

/*
export const GA_EVENT = {
  SWIPE:{           category:'landing',    action:'swipe',                    label:null,       value:null},
  TAP:{             category:'main',       action:'tap',                      label:null,       value:null},
  FACEBOOK_TOP:{    category:'share',      action:'share_facebook_top',       label:null,       value:null},
  MENU_CLOSE:{      category:'menu',       action:'close',                    label:null,       value:null}
}

eg: AnalyticsService.sendEventObj(GA_EVENT.CLOSE)

AnalyticsService.sendEventObj(Object.assign({},GA_EVENT.CLOSE, {label: `someData${value}`})
*/


